import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-unapplied-changes-confirmation-dialog',
    imports: [MatCardModule, MatButtonModule, MatDialogClose],
    templateUrl: './unapplied-changes-confirmation-dialog.component.html',
    styleUrl: './unapplied-changes-confirmation-dialog.component.scss'
})
export class UnappliedChangesConfirmationDialogComponent {
    /**
     * Constructeur.
     * @param dialogRef
     * @param data
     */
    constructor(
        public dialogRef: MatDialogRef<UnappliedChangesConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}
}
